module.exports = __webpack_public_path__ + "img/services-details-3.5eb5da64.jpg";